module.exports = __webpack_public_path__ + "media/images/menu/caelum-314df807f821fda32801b621dfa60dc9.jpg";